import React from 'react';
import PropTypes from 'prop-types';
import css from './ExportPopover.css';
import GenericPopover from './GenericPopover';

const ExportPopover = ({
    show = false,
    exportOptions = [{ label: 'Export to CSV', id: 'exportCsv' }],
    onInnerShowChanged = () => {},
    onItemClicked = () => {},
}) => {
    const handleItemClick = e => {
        const itemId = e.target.id.replace('export_popover_item_', '');
        onItemClicked(itemId);
    };

    return (
        <GenericPopover show={show} onInnerShowChanged={onInnerShowChanged}>
            <ul className={css.container} onClick={handleItemClick}>
                {exportOptions.map(item => {
                    return (
                        <li key={item.id} className={css.item} id={`export_popover_item_${item.id}`}>
                            {item.label}
                        </li>
                    );
                })}
            </ul>
        </GenericPopover>
    );
};

ExportPopover.propTypes = {
    show: PropTypes.bool,
    exportOptions: PropTypes.arrayOf(PropTypes.any),
    onInnerShowChanged: PropTypes.func,
    onItemClicked: PropTypes.func,
};

export default ExportPopover;
